import Vue from 'vue'

import store from './store'
import ElementUI from 'element-ui'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets
// 引入 Font Awesome Free 全部样式
import '@fortawesome/fontawesome-free/css/all.min.css'
import i18n from "./lang";
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VueTelInput from "@/components/Vuetelinput/index.vue";
import loading from "@/components/loading/loading.vue"

import "@/assets/font-Roboto/font.css"
import '@/styles/element-variables.scss'
import '@/styles/index.scss' // global css，需要放在 Element UI 主题样式之后
import '@flaticon/flaticon-uicons/css/regular/straight.css' // fi图标库
import '@flaticon/flaticon-uicons/css/solid/rounded.css'
import '@flaticon/flaticon-uicons/css/regular/rounded.css'

import App from './App'
import router from './router'
import '@/icons' // icon
import '@/permission' // permission control
import directive from "@/directive";

import WebIM from './IM/webIM.js';  // 环信客服聊天
Vue.prototype.$webIM = WebIM;
import { loadStripe } from '@stripe/stripe-js';
export const stripePK =
  process.env.NODE_ENV === "production"
    ? "pk_live_51SI3fMIc5bwtPu2xzWoRyGjVMPcBnaOaWmEvNEfT9qp8dwkoeBnNDCxZFv62cwYutsfKdd70hyzNcoXdEPMrzRD900CcalBgSt"
    : "pk_test_51SI3fMIc5bwtPu2xvdM4vF41v6HwZliZ4uzFmQkgDJwZ99rCEbRBOzmnCdmikWPKTqDVD1UivQ8X4eIAHfMazgvG00pPzOpZeI";

loadStripe(stripePK).then(stripe => {
  Vue.prototype.$stripe = stripe
})
const EventBus = new Vue()
Vue.prototype.$eventBus = EventBus
Vue.prototype.$webIM.conn.addEventHandler("eventName", {
  //当前用户收到图片消息。
  onImageMessage: function (message) {
    EventBus.$emit('new-im-message', message)
    EventBus.$emit('im-get-num', message)
  },
  // 当前用户收到文字消息。
  onTextMessage: function (message) {
    EventBus.$emit('new-im-message', message)
    EventBus.$emit('im-get-num', message)
  },
  onReceivedMessage: function (message) { // 收到消息送达服务器回执
    EventBus.$emit('im-onReceivedMessage', message)
  },
});
import Decimal from 'decimal.js'  // 精度计算
Vue.prototype.$decimal = Decimal;
import {getPriceToLocale} from "./views/oms/platformOrder/common"
Vue.prototype.$getPriceToLocale = getPriceToLocale;


import {installFilters} from './filters'
// 安装所有过滤器
installFilters(Vue)

// 分页组件 全局挂载
import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination)


// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css';
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

Vue.component('el-collapse-transition', CollapseTransition)

import hurixPagination from "@/components/hurixPagination"
Vue.component('hurixPagination', hurixPagination)

import {formatTimestamp} from '@/utils/index'

Vue.prototype.$formatTimestamp = formatTimestamp;

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)// 在注册Element时设置i18n的处理方法
})
Vue.use(ElementUI, {locale})
Vue.use(directive)

Vue.component('vue-tel-input', VueTelInput)
Vue.component('loading', loading)

Vue.config.productionTip = false

Vue.prototype.$fileDomain = process.env.NODE_ENV === 'production' ? 'https://file.hurix.shop/' : 'https://file.hurix.cc/'

const initApp = async () => {
  const {country} = await store.dispatch('GetLocalIP')
  const isCN = country === 'CN'
  if (!localStorage.getItem('language-admin')) {
    i18n.locale = isCN ? 'zh' : 'en';
    localStorage.setItem('language-admin', isCN ? 'zh' : 'en');
  }
  // 设置 i18n 语言

  new Vue({
    el: '#app',
    i18n,
    router,
    store,
    template: '<App/>',
    components: {App}
  })

  Vue.prototype.$timeFormat = (showTime = true) => {
    if (showTime) return isCN ? 'yyyy-MM-dd HH:mm:ss' : 'dd-MM-yyyy HH:mm:ss'
    return isCN ? 'yyyy-MM-dd' : 'dd-MM-yyyy'
  }
}


initApp()



// WEBPACK FOOTER //
// ./src/main.js